export default __webpack_public_path__ + "static/media/08_TATA Motors.e4e12537.png";